export default __webpack_public_path__ + "static/media/ourStory.446ec735.jpg";